import { Button } from '../primitives/Button'

export type SuggestionAction = 'replace' | 'insert' | 'copy'

export interface SuggestionActionsProps {
  onAction: (action: SuggestionAction) => void
  canEdit?: boolean
}

/** The Ersetzen / Einfügen / Kopieren row under an assistant suggestion. */
export function SuggestionActions({ onAction, canEdit = true }: SuggestionActionsProps) {
  return (
    <div className="flex flex-wrap gap-2 pt-1">
      {canEdit && (
        <>
          <Button variant="primary" size="sm" onClick={() => onAction('replace')}>
            Ersetzen
          </Button>
          <Button size="sm" onClick={() => onAction('insert')}>
            Einfügen
          </Button>
        </>
      )}
      <Button size="sm" onClick={() => onAction('copy')}>
        Kopieren
      </Button>
    </div>
  )
}
